import { createFileRoute } from '@tanstack/react-router'

import { EditRecurringExpensePage } from '@/pages/expenses/recurring/[id]/edit/EditRecurringExpensePage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/expenses/recurring/$id/edit/',
)({
  component: EditRecurringExpensePage,
})
